import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import * as serviceWorker from './serviceWorker';
import history from './utils/history.js';

import App from './App';
import { CmsDataProvider } from 'context/cmsData';
import AmpEmailAPI from 'api/AmpEmailAPI';

import './styles/tailwind_output.css';
import './index.css';
import './component/layout'

// Track page views via AMP API (GTM handles analytics)
history.listen(location => {
  try {
    // Skip AMP tracking in development (CORS issues)
    if (process.env.NODE_ENV !== 'development') {
      AmpEmailAPI.trackPage(location.pathname.replace("/", ""));
    }
  } catch (error) {
    console.warn('Tracking error:', error);
  }
});

ReactDOM.render(
  <React.StrictMode>
    <Router history={history}>
      <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_CAPTCHA_KEY}>
        <CmsDataProvider>
          <App />
        </CmsDataProvider>
      </GoogleReCaptchaProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
